import * as types from '../types'
import update from 'immutability-helper'

export const initialLoginForm = {
    CompleteName: '',
    ApplicantCode: '',
    CompanyId: 0,
}

const defaultState = {
    loading: false,
    error: false,
    loginForm: { ...initialLoginForm },
    alert: {
        show: false,
        title: 'Login Success',
        content: 'Login Successfully.',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
    },
}

export default function loginReducer(state = defaultState, action) {
    switch (action.type) {
        // LOGIN FORM FIELDS
        case types.CHG_LOGIN_DATA:
            return update(state, {
                loginForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            })
        case types.IS_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            })
        case types.CHG_COMP_ID:
            return update(state, {
                CompanyId: { $set: action.payload }
            })
        case types.ERR_404:
            return update(state, {
                error: { $set: action.payload }
            })
        case types.UPD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.HIDE_ALERT:
            return update(state, {
                alert: { show: { $set: false } }
            });
        default: return state;
    }
}